(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('HistoricoMapasService', HistoricoMapasServiceFactory);

  HistoricoMapasServiceFactory.$inject = [
    '$http',
    'NumberUtils',
    'RestService'
  ];

  // eslint-disable-next-line max-lines-per-function
  function HistoricoMapasServiceFactory($http, NumberUtils, RestService) {
    return {
      listTypes,
      listMaps,
      get,
      processShape,
      saveMap,
      inactivateMap,
      update
    };

    //////////////////////////////////////////
    // Function declarations

    function listTypes() {
      return $http.get(`${SERVER}v1/mapas/tipos`);
    }

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    function listMaps(filters) {
      const params = !filters ? {} : {
        page: filters.page || null,
        safra: (filters.safra || {}).id || null,
        gleba: (filters.gleba || {}).id || null,
        subtipo: (filters.subtipo || {}).id || null,
        propriedade: (filters.propriedade || {}).id || null,
        tipo: (filters.tipo || {}).id || null,
        start_date: filters.dataInicial || null,
        end_date: filters.dataFinal || null,
        favorites: filters.favorites
      };

      return RestService.getFromUrl(`${SERVER}v1/mapas`, params);
    }

    function get(id) {
      return $http.get(`${SERVER}v1/mapas/${id}`).then(({ data }) => {
        if ((data.dados || {}).geojson) {
          const found = data.dados.geojson.features.find((item) => !!Object.keys(item.properties)[0]);
          data.field = Object.keys(found.properties)[0];

          // TODO: rever complexity
          // eslint-disable-next-line complexity
          data.indexedPoints = data.dados.geojson.features.reduce((result, feature) => {
            if (typeof feature.properties[data.field] !== 'undefined') {
              const coordinatesAccuracy = (feature.geometry.coordinates[0][0] || [])
                .map((item) => NumberUtils.truncate(item, 4));
              const coordinates = (feature.geometry.coordinates[0][0] || [])
                .map((item) => NumberUtils.truncate(item, 3));
              result[coordinates[0]] = result[coordinates[0]] || {};
              result[coordinates[0]][coordinates[1]] = feature.properties;

              result[coordinatesAccuracy[0]] = result[coordinatesAccuracy[0]] || {};
              result[coordinatesAccuracy[0]][coordinatesAccuracy[1]] = feature.properties;
            }
            return result;
          }, {});
        }

        return data;
      });
    }

    function processShape(shape) {
      return $http.post(`${SERVER}v1/mapas/shape_fields`, { shape });
    }

    function saveMap(mapa) {
      return $http.post(`${SERVER}v1/mapas`, { mapa });
    }

    function inactivateMap(mapa, params) {
      return $http.patch(`${SERVER}v1/mapas/inactivate/${mapa}`, params);
    }

    function update(mapa, params) {
      return $http.patch(`${SERVER}v1/mapas/${mapa}`, { mapa: params });
    }
  }
}());
